import React, { useContext, useEffect, useState } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import MatchingReports from '../../components/MatchingReports';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';
import { useHistory } from 'react-router-dom';

const MatchingReportsPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const history = useHistory();
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    if (role !== "admin") {
       history.push("/dashboard");
     }
   }, []);

  return (
    <>  
      { role === "admin" ? <AdminHeader trigger={trigger} /> : <LoginHeader trigger={trigger} /> }
      <main>
        {role === "admin" && <MatchingReports />}
      </main>
      <LoginFooter />
    </>
  )
}

export default MatchingReportsPage;